import MaterialIconsReact from "material-icons-react";
import React, { useEffect } from "react";
import Button from "./Button";
import styles from "./Toast.module.css";

function Toast(props) {
  useEffect(() => {
    const interval = setInterval(() => {
      if (props.toastList.length > 0 && props.toastList[0].autoClose === true) {
        deleteToast(props.toastList[0].id);
      }
    }, 3000);
    return () => {
      clearInterval(interval);
    }
  }, [props.toastList])

  const deleteToast = (id) => {
    const toastListItem = props.toastList.findIndex(e => e.id === id);
    props.toastList.splice(toastListItem, 1);
    props.setToastList([...props.toastList]);
  }

  return (
    <div className={styles.toastWrapper}>
      {props.toastList.map((item, index) => {
        return (
          <div key={index} className={styles.toast + ' ' + styles[item.type]}>
            <div data-testid={'toast' + index} className={styles.toastTitle + ' ft-16'}>{item.text}</div>
            {!item.autoClose && <MaterialIconsReact data-testid={'close' + index} icon="close" color={item.type === 'info' ? 'black' : 'white'} size={20} onClick={() => deleteToast(item.id)}></MaterialIconsReact>}
            {item.onClick && <Button data-testid={'button' + index} style={{marginTop: '12px'}} type="primary" onClick={item.onClick} invert>Undo</Button>}
          </div>
        )
      })}
    </div>
  );
}

export default Toast;